export default __webpack_public_path__ + "static/media/ösg-logo.66ec5d68.webp";